import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    tax : {
        label : '',
        code : '',
        rate : ''
    },
    taxList : []
};

const taxes = {
    namespaced : true,
    actions,
    getters,
    mutations,
    state,
}

export default taxes;

